import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f0f2f5"}},[_c(VCol,{attrs:{"cols":"10","offset":"1"}},[_c('h2',{staticClass:"ma-5 text-center app--text"},[_vm._v("\n      Choose a community from the ones below\n    ")]),_vm._v(" "),(_vm.groups.length === 0)?_c('groups-skeleton'):_vm._e(),_vm._v(" "),(_vm.groups)?_c(VRow,_vm._l((_vm.groups),function(group){return _c(VCol,{key:group.id,attrs:{"cols":"3"}},[_c('GroupCard',{attrs:{"group":group}})],1)}),1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }